import { render, staticRenderFns } from "./ConversationsSettings.vue?vue&type=template&id=3ddd82ee&scoped=true"
import script from "./ConversationsSettings.vue?vue&type=script&lang=js"
export * from "./ConversationsSettings.vue?vue&type=script&lang=js"
import style0 from "./ConversationsSettings.vue?vue&type=style&index=0&id=3ddd82ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddd82ee",
  null
  
)

export default component.exports